import type { Theme } from "../tokens";

/** A national post office's design manual, applied to software. */
export const grotesk: Theme = {
  id: "grotesk",
  name: "Grotesk",
  thesis: "A national post office's design manual, applied to software.",
  scheme: "light",
  colors: {
    ground: "#FFFFFF",
    surface: "#FFFFFF",
    raised: "#F4F4F4",
    ink: "#111111",
    dim: "#767676",
    rule: "#DCDCDC",
    lattice: "#EBEBEB",
    focus: "#0057B8",
    inbox: "#E2231A",
    feed: "#0057B8",
    paperTrail: "#767676",
    screener: "#111111",
  },
  type: {
    sans: "'Archivo', system-ui, sans-serif",
    mono: "'Archivo', system-ui, sans-serif",
    googleFonts: "Archivo:wght@400;600;700",
    tracking: "-0.01em",
  },
  density: {
    row: 48,
    primary: 16,
    secondary: 15,
    meta: 13,
    listWidth: 720,
    rail: 248,
    radius: 0,
    lineHeight: 1.4,
  },
  markers: {
    inbox: "●",
    feed: "◆",
    paperTrail: "▭",
    screener: "▲",
  },
};
